import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ServiceUsage, serviceUsageSearchParams } from '../../types/resources/ServiceUsageType';

const endpoint = '/partner_admins/service_usages';

type GetResponseType = {
  data: {
    service_usages: ServiceUsage[];
  };
  headers: Record<string, string>;
};

export async function getServiceUsages(
  signOut?: () => void,
  searchParams?: serviceUsageSearchParams
): Promise<GetResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `${endpoint}${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function getServiceUsagesCSV(
  signOut?: () => void,
  searchParams?: serviceUsageSearchParams
): Promise<{ data: Blob }> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `${endpoint}.csv${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.blob();

  return { data };
}
